type RelOptions = {
  nofollow?: boolean
  sponsored?: boolean
  rel?: string
}

export function getRelAttribute({
  nofollow,
  sponsored,
  rel,
}: RelOptions): string | undefined {
  return (
    [nofollow && 'nofollow', sponsored && 'sponsored', rel]
      .filter(Boolean)
      .join(' ') || undefined
  )
}
